
import { Component, Prop, Vue, Provide } from 'vue-property-decorator';
import BaiMap from '@/components/BaiMap.vue';

@Component({
    components: {
       BaiMap,
    },
})
export default class TestMap extends Vue {
  public longitude: number = 0; // 精度
  public latitude: number = 0; // 维度
  public location: string = ''; // 位置信息
  public addressList: any[] = []; // 附件百米位置列表
  public errMsg: string = '';

  public getLocation(event: any) {
      this.longitude = event.longitude;
      this.latitude = event.latitude;
      this.addressList = event.address;
      this.location = event.location;
  }

  public getError(err: any) {
    this.errMsg = err.msg;
  }

  public changeLocation() {
      const myMap: any = this.$refs.baiduMap;
      myMap.getLocationByGPS();
  }
}
